import { render, staticRenderFns } from "./CrmLeadReminderListApi.vue?vue&type=template&id=06565ce1&lang=pug&"
import script from "./CrmLeadReminderListApi.vue?vue&type=script&lang=js&"
export * from "./CrmLeadReminderListApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports